import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography
} from "@mui/material";
import { toast } from "react-toastify";
import queueService from "../services/queueService";
import ticketService from "../services/ticketService";

const NewTicketModal = ({ modalOpen, initialContact, onClose, onCreated }) => {
  const [queues, setQueues] = useState([]);
  const [queueId, setQueueId] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!modalOpen) return;
    let active = true;
    (async () => {
      setLoading(true);
      try {
        const response = await queueService.getQueues();
        const rows = response?.data || response || [];
        if (!active) return;
        const list = Array.isArray(rows) ? rows : [];
        setQueues(list);
        if (list.length) setQueueId(String(list[0].id));
      } catch (_) {
        if (active) setQueues([]);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, [modalOpen]);

  const handleCreate = async () => {
    if (!initialContact?.id) {
      toast.error("Contato inválido");
      return;
    }
    if (!queueId) {
      toast.error("Selecione uma fila");
      return;
    }
    setLoading(true);
    try {
      const res = await ticketService.createTicket({ contactId: initialContact.id, queueId: Number(queueId) });
      const ticket = res?.ticket || res?.data?.ticket || res?.data || null;
      toast.success("Ticket criado");
      onClose?.();
      onCreated?.(ticket);
    } catch (_) {
      toast.error("Erro ao criar ticket");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={!!modalOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Novo ticket</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
          Contato: {initialContact?.name || ""} {initialContact?.number ? `(${initialContact.number})` : ""}
        </Typography>
        <FormControl fullWidth margin="normal" disabled={loading}>
          <InputLabel>Fila</InputLabel>
          <Select
            value={queueId}
            onChange={(e) => setQueueId(e.target.value)}
            label="Fila"
          >
            {queues.map((q) => (
              <MenuItem key={q.id} value={String(q.id)}>{q.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose} disabled={loading}>Cancelar</Button>
        <Button onClick={handleCreate} disabled={loading || !queueId} variant="contained">Criar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewTicketModal;
